import type { ComponentProps } from 'react'
import * as TabsPrimitive from '@radix-ui/react-tabs'
import clsx from 'clsx'
import { useContext } from 'react'
import { Card } from './Card'
import { ThemeContext } from './ThemeContext'

function Root(props: ComponentProps<typeof TabsPrimitive.Root>) {
  const { children, className, ...rootProps } = props

  return (
    <TabsPrimitive.Root {...rootProps} asChild>
      <Card className={clsx('grid size-full grid-rows-[auto_1fr] overflow-hidden', className)}>
        {children}
      </Card>
    </TabsPrimitive.Root>
  )
}

function List({ className, children }: ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List className={clsx('flex', className)}>
      {children}
    </TabsPrimitive.List>
  )
}

function Trigger({ value, className, isActive, children }: {
  isActive: boolean
} & ComponentProps<typeof TabsPrimitive.Trigger>) {
  const { mainColor } = useContext(ThemeContext)

  const style = {
    active: {
      borderBottomColor: mainColor,
    },
    inactive: {
      color: '#AAABAA',
    },
  }

  return (
    <TabsPrimitive.Trigger
      className={clsx('h-[52px] border-b-2 border-b-transparent px-4 py-3 text-sm font-bold', className)}
      style={isActive ? style.active : style.inactive}
      value={value}
    >
      {children}
    </TabsPrimitive.Trigger>
  )
}

function Content({ value, children }: {
  value: string
  children: React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>['children']
}) {
  return (
    <TabsPrimitive.Content
      className="h-full"
      value={value}
    >
      {children}
    </TabsPrimitive.Content>
  )
}

export const Tabs = {
  Root,
  List,
  Trigger,
  Content,
}
